import type { ReactNode, ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'default' | 'ghost' | 'link';
type Size = 'sm' | 'md';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
  variant?: Variant;
  size?: Size;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  htmlType?: 'button' | 'submit' | 'reset';
};

export function Button({
  variant = 'default',
  size = 'md',
  leftIcon,
  rightIcon,
  htmlType = 'button',
  className,
  children,
  ...rest
}: Props) {
  const cls =
    'btn' +
    (variant === 'primary' ? ' btn-primary' : '') +
    (variant === 'ghost' ? ' btn-ghost' : '') +
    (variant === 'link' ? ' btn-link' : '') +
    (size === 'sm' ? ' btn-sm' : '') +
    (className ? ' ' + className : '');
  return (
    <button type={htmlType} className={cls} {...rest}>
      {leftIcon}
      {children}
      {rightIcon}
    </button>
  );
}
